(function() {
    'use strict';

    angular.module('remitEventsApp').factory('ProductionUnit', function($resource) {
        return $resource(
            'api/productionUnits/:id',
            {},
            {
                query: { method: 'GET', isArray: true },
                get: {
                    method: 'GET',
                    transformResponse: function(data) {
                        data = angular.fromJson(data);
                        return data;
                    }
                },
                update: { method: 'PUT' }
            }
        );
    });
})();
